"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOURCE_APP = exports.PRODUCT_INTENTS = exports.LEAD_GEN_BTN_WINDOW_KEYS = exports.LEAD_GEN_BTN_TYPES = void 0;
exports.getBundleUrl = getBundleUrl;
exports.isLeadGenAvailable = isLeadGenAvailable;
exports.isLeadGenLoadErrorEvent = isLeadGenLoadErrorEvent;
exports.isLeadGenLoadLoadingEvent = isLeadGenLoadLoadingEvent;
exports.isLeadGenLoadSuccessEvent = isLeadGenLoadSuccessEvent;
exports.isValidProductIntent = isValidProductIntent;
const NOTIFICATION_EVENTS = {
  LOADER_LOADING: 'lead-gen.loader.loading',
  LOADER_ERROR: 'lead-gen.loader.error',
  MODAL_LOADED: 'lead-gen.modal.loaded',
  EMBED_LOADED: 'lead-gen.embed.loaded'
};
const SOURCE_APP = exports.SOURCE_APP = 'pattern-library';
const LEAD_GEN_BTN_TYPES = exports.LEAD_GEN_BTN_TYPES = {
  MARKETING: 'dify-lead-gen',
  COMMERCE: 'commerce-lead-gen'
};
const MKTG_PRODUCT_INTENTS = {
  MARKETING_SERVICES: 'Marketing Services',
  SEO_SERVICE: 'SEO Service',
  WEBSITE_DESIGN_SERVICES: 'Website Design Services'
};
const COMMERCE_PRODUCT_INTENTS = {
  COMMERCE_SMART_TERMINAL: 'Commerce - Smart Terminal'
};
const LEAD_GEN_BTN_WINDOW_KEYS = exports.LEAD_GEN_BTN_WINDOW_KEYS = {
  [LEAD_GEN_BTN_TYPES.MARKETING]: 'difyLeadGen',
  [LEAD_GEN_BTN_TYPES.COMMERCE]: 'commerceLeadGen'
};
const PRODUCT_INTENTS = exports.PRODUCT_INTENTS = {
  [LEAD_GEN_BTN_TYPES.MARKETING]: [MKTG_PRODUCT_INTENTS.MARKETING_SERVICES, MKTG_PRODUCT_INTENTS.SEO_SERVICE, MKTG_PRODUCT_INTENTS.WEBSITE_DESIGN_SERVICES],
  [LEAD_GEN_BTN_TYPES.COMMERCE]: [COMMERCE_PRODUCT_INTENTS.COMMERCE_SMART_TERMINAL]
};

/**
 * Gets the Source URL for the required Marketing Lead Gen Form bundle version
 * @param {string} version The Marketing Lead Gen Form bundle version
 * @param {string} leadingGenType The type of lead gen, defaults to 'dify-lead-gen'
 * @returns {string} Source URL
 */
function getBundleUrl(version, leadingGenType = LEAD_GEN_BTN_TYPES.MARKETING) {
  return version ? `https://img1.wsimg.com/blobby/go/static/engagement/${leadingGenType}/${version}/${leadingGenType}-loader-bundle.js` : '';
}

/**
 * Returns the if the lead gen key is part of the window object
 * @param {string} type The type of lead gen to check for, defaults to 'dify-lead-gen'
 * @returns {undefined | object} leadGen object
 */
function isLeadGenAvailable(type = LEAD_GEN_BTN_TYPES.MARKETING) {
  return !!window?.[LEAD_GEN_BTN_WINDOW_KEYS[type]];
}

/**
 * Validates against the PRODUCT_INTENTS object.
 * @description Checks if the product intent is valid for the given lead type.
 * @param {*} leadType the type of lead gen, e.g., 'dify-lead-gen' or 'commerce-lead-gen'.
 * @param {*} productIntent the product intent to validate, e.g., 'Marketing Services'.
 * @returns {boolean} True if the product intent is valid for the lead type, false otherwise.
 */
function isValidProductIntent(leadType, productIntent) {
  const allowed = PRODUCT_INTENTS[leadType];
  return allowed ? allowed.includes(productIntent) : true;
}

/**
 * Checks if a Window Message Event contains a Lead Gen error event
 * @param {*} event Message Event
 * @returns {boolean} True if the event has an error event, false otherwise
 */
function isLeadGenLoadErrorEvent(event) {
  const isSameOrigin = event.origin === window.origin;
  const isErrorEvent = event.data?.event === NOTIFICATION_EVENTS.LOADER_ERROR;
  return isSameOrigin && isErrorEvent;
}

/**
 * Checks if a Window Message Event contains a Lead Gen loading event
 * @param {*} event Message Event
 * @returns {boolean} True if the event has an loading event, false otherwise
 */
function isLeadGenLoadLoadingEvent(event) {
  const isSameOrigin = event.origin === window.origin;
  const isLoadingEvent = event.data?.event === NOTIFICATION_EVENTS.LOADER_LOADING;
  return isSameOrigin && isLoadingEvent;
}

/**
 * Checks if a Window Message Event contains a Lead Gen success event
 * @param {*} event Message Event
 * @returns {boolean} True if the event has an success event, false otherwise
 */
function isLeadGenLoadSuccessEvent(event) {
  const isSameOrigin = event.origin === window.origin;
  const isSuccessEvent = event.data?.event === NOTIFICATION_EVENTS.EMBED_LOADED || event.data?.event === NOTIFICATION_EVENTS.MODAL_LOADED;
  return isSameOrigin && isSuccessEvent;
}